import { cn } from "@faire/prototype-playground/lib/utils";
import * as React from "react";

export type SlateStyleOverrideProps = {
  children: React.ReactNode;
  className?: string;
};

/** Prototype escape hatch for piercing styles into Slate internals
 * @important you MUST read `playground-prototypes` → `references/override-slate-component-styling.md` before use
 */
export const SlateStyleOverride: React.FC<SlateStyleOverrideProps> = ({
  children,
  className,
}) => {
  return <div className={cn("contents", className)}>{children}</div>;
};
